import React, { Component } from 'react';
import _ from 'lodash';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import {
  withStyles,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import { Form } from 'react-final-form'
import { isAdminCurrent } from 'utils/helpers'

import { FormField } from 'components';

import styles from './styles';
import getFields from './fields';

class UserForm extends Component {

  state = {
    isChangingPassword: false,
    fields: null,
  }

  async componentDidMount() {
    this.setState({
      fields: await getFields(),
    });
  }
  
  validate(values) {
    const { user, t } = this.props;
    const { isChangingPassword } = this.state;
    let errors = {};

    if (!values.firstName) {
      errors.firstName = t('Privalomas laukas');
    }

    if (!values.email) {
      errors.email = t('Privalomas laukas');
    }

    if (!user || isChangingPassword) {
      if (!values.password) {
        errors.password = t('Privalomas laukas');
      }

      if (!values.confirmPassword) {
        errors.confirmPassword = t('Privalomas laukas');
      }

      if((values.password && values.confirmPassword) && (values.password != values.confirmPassword)) {
        errors.confirmPassword = t('Slaptažodžiai nesutampa');
      }
    }

    return errors;
  }

  render() {
    const {
      classes,
      user,
      onSubmit,
      t,
    } = this.props;

    const { isChangingPassword } = this.state;
    const showPasswordFields = (!user && !isChangingPassword) || (user && isChangingPassword);
    return (
      <Form
        initialValues={{ password: '', ...user }}
        onSubmit={onSubmit}
        validate={this.validate.bind(this)}
        render={({ handleSubmit }) => (
          <form
            id="userForm"
            className={classes.form}
            onSubmit={handleSubmit}
            autoComplete="off"
          >
            { _.map(this.state.fields, field => field.name == "comment" && !isAdminCurrent() ? null : <FormField key={field.name} {...field}/>)}

            {user ? (
              <div>
                <FormControlLabel
                  label={t('Keisti slaptažodį')}
                  className={classes.checkboxWrap}
                  control={
                    <Checkbox
                      checked={isChangingPassword}
                      onChange={({ target }) => {this.setState({ isChangingPassword: target.checked })}}
                    />
                  }
                />
              </div>
            ) : null}

            {showPasswordFields ? (
              <div>
                <FormField name="password" type="password" label={t('Slaptažodis')} autoComplete="new-password"/>
                <FormField name="confirmPassword" type="password" label={t('Pakartokite slaptažodį')}/>
              </div>
            ) : null}

            
          </form>
        )}
      />
    );
  }
}

export default compose(withStyles(styles), withTranslation())(UserForm);
